<template>
    <div>
        <rkm-row>
            <rkm-col>
                <rkm-form-radio-group v-model="data.model.desfechoId">
                    <rkm-form-radio
                        v-if="(isSaved && data.model.desfechoId == enums.desfecho.PACIENTE_LIBERADO) || !isMedico"
                        :value="enums.desfecho.PACIENTE_LIBERADO"
                    >Paciente atendido</rkm-form-radio>
                    <rkm-form-radio
                        v-else
                        :value="enums.desfecho.ALTA_MEDICA"
                    >Alta médica</rkm-form-radio>
                    <rkm-form-radio :value="enums.desfecho.EVASAO">Evasão</rkm-form-radio>
                    <rkm-form-radio :value="enums.desfecho.ENCAMINHAMENTO_HOSPITALAR">Transferência / Encaminhamento hospitalar</rkm-form-radio>
                    <rkm-form-radio :value="enums.desfecho.OBITO">Óbito</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="data.model.desfechoId == enums.desfecho.PACIENTE_LIBERADO">
            <rkm-col>
                <rkm-form-select
                    :options="data.form.usuariosNaoMedicosDesfecho"
                    :validations="validations.pacienteLiberado.usuarioId"
                    label="Profissional responsável"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.pacienteLiberado.lotacaoId"
                    value-field="lotacaoId"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="data.model.desfechoId == enums.desfecho.ALTA_MEDICA">
            <rkm-col>
                <rkm-form-select
                    :options="data.form.usuariosDesfecho"
                    :validations="validations.altaMedica.usuarioId"
                    label="Médico responsável"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.altaMedica.lotacaoId"
                    value-field="lotacaoId"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="data.model.desfechoId == enums.desfecho.EVASAO">
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.evasao.motivo"
                    label="Motivo da evasão"
                    v-model="data.model.evasao.motivo"
                />
            </rkm-col>
        </rkm-row>

        <template v-if="data.model.desfechoId == enums.desfecho.ENCAMINHAMENTO_HOSPITALAR">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.usuariosDesfecho"
                        :validations="validations.encaminhamentoHospitalar.usuarioId"
                        label="Médico responsável (PA)"
                        show-default-option
                        text-field="nome"
                        v-model="data.model.encaminhamentoHospitalar.lotacaoId"
                        value-field="lotacaoId"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        v-if="data.model.encaminhamentoHospitalar.unidadeOutra === false"
                        :options="data.form.unidades"
                        :validations="validations.encaminhamentoHospitalar.unidadeId"
                        label="Unidade de encaminhamento"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="data.model.encaminhamentoHospitalar.unidadeId"
                        value-field="id"
                    />

                    <rkm-form-input
                        v-else
                        :validations="validations.encaminhamentoHospitalar.unidadeNome"
                        label="Nome"
                        v-model="data.model.encaminhamentoHospitalar.unidadeNome"
                    />
                </rkm-col>

                <rkm-col
                    class="pt-2"
                    cols="2"
                >
                    <div class="d-flex mt-4">
                        <rkm-form-checkbox
                            inline
                            v-model="data.model.encaminhamentoHospitalar.unidadeOutra"
                        >
                            Outra
                        </rkm-form-checkbox>
                    </div>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.encaminhamentoHospitalar.quarto"
                        label="Quarto"
                        v-model="data.model.encaminhamentoHospitalar.quarto"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.encaminhamentoHospitalar.leito"
                        label="Leito"
                        v-model="data.model.encaminhamentoHospitalar.leito"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        label="Médico hospitalar"
                        :validations="validations.encaminhamentoHospitalar.medicoHospitalar"
                        v-model="data.model.encaminhamentoHospitalar.medicoHospitalar"
                        uppercase
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :repository="repositories.cid"
                        :searchFields="fields.autocomplete.cid"
                        :validations="validations.encaminhamentoHospitalar.cidId"
                        label="CID10"
                        v-model="data.model.encaminhamentoHospitalar.cid"
                    >
                        <template v-slot:itemLabel="{ item }">
                            {{ item.codigo | formatCid }} - {{ item.nome }}
                        </template>
                    </rkm-form-input-autocomplete>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :validations="validations.encaminhamentoHospitalar.observacoes"
                        label="Observações"
                        v-model="data.model.encaminhamentoHospitalar.observacoes"
                    />
                </rkm-col>
            </rkm-row>
        </template>

        <template v-if="data.model.desfechoId == enums.desfecho.OBITO">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.usuariosDesfecho"
                        :validations="validations.obito.usuarioId"
                        label="Médico responsável"
                        show-default-option
                        text-field="nome"
                        v-model="data.model.obito.lotacaoId"
                        value-field="lotacaoId"
                    />
                </rkm-col>
            </rkm-row>
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        disabled
                        label="Paciente"
                        v-model="data.form.paciente.nome"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-date-picker
                        :validations="validations.obito.dataObito"
                        :max-date="data.form.dataAtual"
                        label="Data de óbito"
                        v-model="data.model.obito.dataObito"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-time-picker
                        :validations="validations.obito.horaObito"
                        label="Hora de óbito"
                        v-model="data.model.obito.horaObito"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :validations="validations.obito.declaracao"
                        label="Número da declaração de óbito"
                        v-model="data.model.obito.declaracao"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :searchFields="fields.autocomplete.cid"
                        :repository="repositories.cid"
                        :validations="validations.obito.cidId"
                        label="CID10"
                        placeholder="CID10 referente a causa do óbito"
                        v-model="data.model.obito.cid"
                    >
                        <template v-slot:itemLabel="{ item }">
                            {{ item.codigo | formatCid }} - {{ item.nome }}
                        </template>
                    </rkm-form-input-autocomplete>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :validations="validations.obito.causa"
                        label="Causa do óbito"
                        v-model="data.model.obito.causa"
                    />
                </rkm-col>
            </rkm-row>
        </template>
    </div>
</template>

<script>
// Enums.
import desfecho from '@/enums/pronto-atendimento/desfecho'

// Filters.
import formats from '@/filters/formats'

// Mixins.
import { repository } from '@/mixins'

export default {
    computed: {
        fields() {
            return {

                autocomplete: {
                    cid: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true },
                    ],
                },
            }
        },
        validations() {
            return {
                pacienteLiberado: {
                    usuarioId: { required: true },
                },
                altaMedica: {
                    usuarioId: { required: true },
                },
                evasao: {
                    motivo: { required: true, min: 1, max: 200 },
                },
                encaminhamentoHospitalar: {
                    usuarioId: { required: true },
                    unidadeId: { required: true },
                    unidadeNome: {
                        required: true,
                        max: 150
                    },
                    quarto: { max: 3 },
                    leito: { max: 3 },
                    cidId: { required: true },
                    medicoHospitalar: { max: 150, name: true },
                    observacoes: { max: 3000 },
                },
                obito: {
                    usuarioId: { required: true },
                    dataObito: { required: true },
                    horaObito: { required: true },
                    declaracao: { required: true, numeric: true, min: 8, max: 13 },
                    causa: { required: true, min: 1, max: 250 },
                    cidId: { required: true },
                },
            }
        },
    },
    created() {
        this.repositories = {
            cid: this.getConectaSusRepository('sigtap.cid')
        }
    },
    data: () => ({
        enums: { desfecho }
    }),
    filters: {
        ...formats,
    },
    mixins: [ repository, formats ],
    props: {
        data: { type: Object, required: true },
        isMedico: { type: Boolean, default: true },
        isSaved: { type: Boolean, default: false },
    },
    watch: {
        'data.model.encaminhamentoHospitalar.unidadeOutra': function(newValue) {

            if (newValue) {

                this.data.model.encaminhamentoHospitalar.unidadeId = null
            }
        },
        isMedico(isMedico) {

            if (!this.isSaved && ((isMedico && this.data.model.desfechoId == this.enums.desfecho.PACIENTE_LIBERADO)
                || (!isMedico && this.data.model.desfechoId == this.enums.desfecho.ALTA_MEDICA)
            )) {

                this.data.model.desfechoId = null
            }
        }
    }
}
</script>